module.exports = __webpack_public_path__ + "static/img/layout.cdf4342.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/map/img/layout.png
// module id = On13
// module chunks = 1